// export const BASE_URL = 'http://103.59.179.142:3010';
export const BASE_URL = 'https://real-market-api.zahidhasan.online';
// Env
